import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon
    {...props}
    width="120"
    height="138"
    viewBox="0 0 120 138"
    fill="none"
  >
    <g clipPath="url(#clip0_1906_4221)">
      <path
        d="M80.3175 45.6273V32.793H40.6821V45.6273C40.6821 54.6285 46.6834 62.2268 54.9028 64.6421C56.6159 65.1455 57.7944 66.7139 57.7944 68.4992V68.5011C57.7944 70.2864 56.6159 71.8548 54.9028 72.3582C46.6834 74.7735 40.6821 82.3719 40.6821 91.373V104.671H80.3174V91.373C80.3174 82.3709 74.3148 74.7718 66.0939 72.3574C64.3806 71.8542 63.2019 70.2856 63.2019 68.5002C63.2019 66.7145 64.3807 65.1459 66.0939 64.6429C74.315 62.2285 80.3175 54.6294 80.3175 45.6273Z"
        fill="#EBEBFC"
      />
      <path
        d="M66.0942 64.6429C74.3151 62.2285 80.3177 54.6294 80.3177 45.6273V32.793H74.5957V45.6273C74.5957 54.6294 71.6129 62.2285 63.3922 64.6429C61.6789 65.1461 60.5 66.7145 60.5 68.5002C60.5 70.2858 61.6789 71.8544 63.392 72.3574C71.6129 74.7717 74.5956 82.3709 74.5956 91.373V104.671H80.3175V91.373C80.3175 82.3709 74.315 74.7717 66.0941 72.3574C64.3809 71.8542 63.202 70.2858 63.202 68.5002C63.2022 66.7145 64.3811 65.1461 66.0942 64.6429Z"
        fill="#B7B7DC"
      />
      <path
        d="M79.7609 33.9936H41.2391C38.446 33.9936 36.1816 31.7292 36.1816 28.9361V27H84.8182V28.9361C84.8183 31.7292 82.554 33.9936 79.7609 33.9936Z"
        fill="#BB706A"
      />
      <path
        d="M73.7981 27V28.7824C73.7981 31.6605 71.465 33.9936 68.5869 33.9936H79.6069C82.485 33.9936 84.8181 31.6605 84.8181 28.7824V27H73.7981Z"
        fill="#A55B5B"
      />
      <path
        d="M41.2391 103.006H79.7609C82.554 103.006 84.8183 105.271 84.8183 108.064V110H36.1816V108.064C36.1816 105.271 38.446 103.006 41.2391 103.006Z"
        fill="#BB706A"
      />
      <path
        d="M79.6073 103.006H70.1362C73.0142 103.006 75.3474 105.339 75.3474 108.218V110H84.8185V108.218C84.8185 105.34 82.4854 103.006 79.6073 103.006Z"
        fill="#A55B5B"
      />
      <path
        d="M60.4999 60.6434C52.3001 60.6434 45.6528 53.9961 45.6528 45.7963V45.8618C47.0513 46.4616 49.2795 47.2073 51.9936 47.1333C59.7183 46.9228 63.19 40.2954 68.8303 41.1432C70.4768 41.3908 75.005 42.8303 75.3471 45.8618C75.3446 45.84 75.3471 45.8181 75.3471 45.7963C75.3471 53.9961 68.6998 60.6434 60.4999 60.6434Z"
        fill="#FBB84D"
      />
      <path
        d="M60.4999 94.791C65.0373 94.791 68.7156 98.4693 68.7156 103.007V102.971H52.2842V103.007C52.2842 98.4693 55.9624 94.791 60.4999 94.791Z"
        fill="#FBB84D"
      />
      <path
        d="M60.4999 59.3906C59.8078 59.3906 59.2471 59.9515 59.2471 60.6434V64.0166C59.2471 64.7086 59.8078 65.2694 60.4999 65.2694C61.1919 65.2694 61.7526 64.7085 61.7526 64.0166V60.6434C61.7526 59.9515 61.1919 59.3906 60.4999 59.3906Z"
        fill="#FBB84D"
      />
      <path
        d="M60.4999 72.3257C59.8078 72.3257 59.2471 72.8864 59.2471 73.5785V75.7361C59.2471 76.4282 59.8078 76.9889 60.4999 76.9889C61.1919 76.9889 61.7526 76.428 61.7526 75.7361V73.5785C61.7526 72.8866 61.1919 72.3257 60.4999 72.3257Z"
        fill="#FBB84D"
      />
      <path
        d="M60.4999 79.0381C59.8078 79.0381 59.2471 79.599 59.2471 80.2909V80.7595C59.2471 81.4516 59.8078 82.0123 60.4999 82.0123C61.1919 82.0123 61.7526 81.4516 61.7526 80.7595V80.2909C61.7526 79.599 61.1919 79.0381 60.4999 79.0381Z"
        fill="#FBB84D"
      />
      <path
        d="M60.4999 87.6826C59.8078 87.6826 59.2471 88.2435 59.2471 88.9354V94.7021C59.2471 95.394 59.8078 95.9549 60.4999 95.9549C61.1919 95.9549 61.7526 95.394 61.7526 94.7021V88.9354C61.7526 88.2434 61.1919 87.6826 60.4999 87.6826Z"
        fill="#FBB84D"
      />
    </g>
    <defs>
      <clipPath id="clip0_1906_4221">
        <rect
          width="83"
          height="83"
          fill="white"
          transform="translate(19 27)"
        />
      </clipPath>
    </defs>
  </SvgIcon>
));
